// @ts-strict-ignore
import loadable from '@loadable/component'
import EVCoreDefaultComponents from '@h/eevee-components'

interface Component {
  variations: object
  wrapperConfig?: object
  hydrate?: boolean | object
}

interface ComponentMap {
  [key: string]: Component
}

export const Components: ComponentMap = {
  ...EVCoreDefaultComponents,
  table: {
    features: { localDates: true, globalDates: true },
    variations: {
      default: loadable(() => import('../table')),
    },
    hydrate: false,
  },
  breadcrumb: {
    variations: {
      default: loadable(() => import('../breadcrumb-module')),
    },
    wrapperConfig: { spacingTop: 'sm' },
    hydrate: false,
  },
  richTextBlock: {
    variations: {
      default: loadable(() => import('../rich-text-block')),
    },
    wrapperConfig: { childSpacing: true, useContainer: false, noWrapper: true },
    hydrate: false,
  },
  clickOutLinks: {
    variations: {
      default: loadable(() => import('../click-out-links')),
    },
    hydrate: false,
  },
  categoryHeadingModule: {
    variations: {
      default: loadable(() => import('../category-heading-module')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: false,
  },
  button: {
    variations: {
      default: loadable(() => import('../button-link')),
    },
    hydrate: true,
  },
  badge: {
    variations: {
      default: loadable(() => import('../badge')),
    },
    hydrate: false,
  },
  hero: {
    variations: {
      default: loadable(() => import('../hero/hero-module.connected')),
    },
    hydrate: false,
    wrapperConfig: { useContainer: false },
  },
  heroCard: {
    variations: {
      default: loadable(() => import('../hero-card')),
    },
    hydrate: false,
  },
  heroAd: {
    variations: {
      default: loadable(() => import('../hero-ad.connected')),
    },
    hydrate: false,
  },
  iconTile: {
    variations: {
      default: loadable(() => import('../icon-tile')),
    },
    hydrate: true,
  },
  productTable: {
    variations: {
      default: loadable(() => import('../product-table')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: {
      variant: [
        'Rich',
        'Card',
        'HTML',
        'Legacy',
        'LegacyMobileCards',
        'productTransfer',
        'eligibilityResults',
        'eligibilityResultsLegacy',
        'eligibilitySlider',
        'legacyNewMobileStyling',
        'topPicks',
      ],
    },
  },
  form: {
    variations: {
      default: loadable(() => import('../form')),
    },
    hydrate: true,
  },
  sponsoredByTag: {
    variations: {
      default: loadable(() => import('../sponsored-by.connected')),
    },
    hydrate: false,
  },
  component: {
    variations: {
      default: loadable(() => import('../component')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: true,
  },
  contentHeroModule: {
    variations: {
      default: loadable(() => import('../content-hero-module.connected')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: false,
  },
  billboard: {
    variations: {
      default: loadable(() => import('../billboard.connected')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: false,
  },
  spacingOverride: {
    variations: {
      default: loadable(() => import('../spacing-override')),
    },
    hydrate: false,
  },
  collectionModule: {
    variations: {
      default: loadable(() => import('../collection-module')),
    },
    hydrate: { layout: ['carousel', 'tabs'] },
  },
  accordion: {
    variations: {
      default: loadable(() => import('../accordion')),
    },
    wrapperConfig: { useContainer: true },
    hydrate: true,
  },
  quoteBlock: {
    variations: {
      default: loadable(() => import('../quote-block')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: false,
  },
  ifttt: {
    variations: {
      default: loadable(() => import('../what-if-then-else')),
    },
    wrapperConfig: { useContainer: false },
    hydrate: true,
  },
  providersLogoModule: {
    variations: {
      default: loadable(() => import('../providers-logo-modules')),
    },
    hydrate: false,
  },
  leadCaptureForm: {
    variations: {
      default: loadable(() => import('../email-capture-form')),
    },
    hydrate: false,
  },
  platinumModules: {
    variations: {
      default: loadable(() => import('../platinum-modules')),
    },
  },
  callOut: {
    variations: {
      default: loadable(() => import('../callout')),
    },
    wrapperConfig: { spacingTop: 'xs', spacingBottom: 'md' },
  },
  aggregationTable: {
    variations: {
      default: loadable(() => import('../aggregation-table')),
    },
  },
}
